import axios from 'axios'

/*
  Follow orderStatus for component state transitions:

  NONE - Nothing has happened yet
  RQPAYMENT - Transaction Processor Payment ReQuirements; may be ommitted
    card details are locally gathered.
  INPROCESS - Requirements have been sent to processor, waiting for 
    an external event(s)
  SUCCESS - All has resolved properly.
  FAILURE - Abort Fail.
*/

// initial state
const state = {
  token: 'sandbox_9q3x8dsp_x8d6qycq8k6h7dsh',
  orderStatus: 'NONE', // NONE, RQPAYMENT, INPROCESS, SUCCESS, FAILURE
  nonce: '',
  ts_submit: '',
  ts_resolved: '',
  transaction: {},
  amount: 0.00
}

// getters
const getters = {
  orderStatus: state => state.orderStatus,
  token: state => state.token,
  amount: state => state.amount,
  nonce: state => state.nonce
}

// actions
const actions = {
    setNonce ({ commit }, nonce ) {
        commit('nonce', nonce)
    },
    checkoutReady ({ commit }, amount) {
        commit('amount',amount)
        commit('orderStatus','RQPAYMENT')
    },
    createTransaction ({ commit }, amount) {
        commit('amount',amount)
        commit('orderStatus','INPROCESS')
    },
    setResp ({ commit }, resp ) {
        let status = resp.status
        status = status == "success"?"SUCCESS":"FAILURE"
        commit('orderStatus',status)
    },
    getToken({ commit }) {
        axios.get('/api/braintree/client_token')
        .then((payload) => {
            commit('token',payload.data)
            commit('orderStatus','RQPAYMENT')
        })
        .catch((err) => {
console.log('ERROR','getToken',err)
        })
    }
}

// mutations
const mutations = {
  amount (state,amount) { state.amount = amount },
  orderStatus (state,v) { state.orderStatus = v },
  nonce (state,nonce) { state.nonce = nonce },
  token (state,token) { state.token = token }
}

export default {
  state,
  getters,
  actions,
  mutations
}
